import * as React from 'react';
import { Controller } from 'react-hook-form';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { Box, Typography } from '@mui/material';    

// {({ field: { onChange, value }, fieldState: { error }, formState })
export default function CustomSelect({ name, control, label, items, rules }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
          <Typography sx={{ p: 1, minWidth: 120 }}>{label}</Typography>
          <Select {...field} defaultValue='' error={!!error} sx={{ height: 40, width: 140 }}>
            {items.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText sx={{ color: 'error.main', ml: 2 }}>{error?.message}</FormHelperText>
        </Box>
      )}
    />
  );
}
